// 葡萄牙语(Portuguese)
export default {
  coinSpecialOffer: "Oferta especial de recarga de moedas HT",
  buySomeAndGetExtra: "Compre algumas e ganhe mais!",
  balance: "Saldo",
  coins: "{number} moedas",
  coin: "{number} moeda",
  extraCoins: "{number} moedas extras",
  continue: "Continuar",
  byToppingUpYouAgree: "Ao recarregar você concorda com o contrato",
  topUpAgreement: "[Acordo de recarga]",
  htCoin: "Moeda HT",
  scanCodeToLog: "Escaneie o código para logar",
  bindYourHelloTalkAccount:
    "Use o aplicativo HelloTalk para escanear o código e fazer login. Vincule sua conta HelloTalk e recarregue.",
  itemSelection: "Seleção de item",
  paymentAmount: "Montante",
  topUpSuccessful: "Recarga bem-sucedida👏",
  totalCoinsNumber:
    "Você adicionou com sucesso {numberone} moedas e recebeu {numbertwo} moedas extras, totalizando {numberall} moedas.",
  ok: "OK",
  copyLinkToPay:
    "Por favor, copie o link e abra-o com o aplicativo do HelloTalk para completar o pagamento.",
  paymentFailed: "O pagamento falhou",
  creditCardPay: "Pagar com PayPal ou cartão de crédito",
  creditCard: "Cartão de crédito",
};
